<template>
  <div id="app" >
    <router-view/>
    <div class="footer">
     <p class="Copyright">版权所有 云南禾睦笙科技有限公司  </p> 
     <p class="record">备案号:滇ICP备2023009355号-1 增值业务许可证:滇B2-20230197</p>
    </div>
  </div>
</template>

<script>
export default {
    name: "App",
    data() {
    return {
      lastTime: null,
      //10分钟未检测到鼠标点击就退出登录，后台正常校验20h
      timeOut:4*3600 * 1000 * 60,
    }
  },
  created() {
    this.lastTime = new Date().getTime()
  },
   methods: {
    //全局监听得点击事件
    isTimeOut() {
      var currentTime = new Date().getTime();
      // 判断上次最后一次点击的时间和这次点击的时间间隔
       if (currentTime - this.lastTime > this.timeOut) {
       // console.log(this.timeOut);
        //这个是判断 当前用户是否登录，根据自己的情况写
         if (null != localStorage.getItem('Authorization')) {   
        this.$alert('身份验证已过期，请重新登录', '提示', {
          confirmButtonText: '确定',
          callback: action => {
           //这里写路由（跳转到登录页）
            this.$store.commit('logout', 'false')
            localStorage.removeItem('Authorization');
            localStorage.removeItem('permission');
           // this.$router.push({ path: '/login' })
           //this.$router.replace('/login');
          window.location.href = '/'
          }
        });
         }
      } else {
        // 如果在期限内点击，则把这次点击的时间覆盖掉之前存的最后一次点击的时间
        this.lastTime = new Date().getTime()
      }
    }
  }

}
</script>

<style> 
html,
body {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0px;
    margin: 0px;
}
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    widows: 100%;
    height: 100%;
}
.Copyright,.record{
  text-align: center;
  font-size: 18px;
  color: #606266;

}
.record{
line-height: 20px;
margin-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue